import { useState } from 'react'
import { toast } from 'sonner'
import { api } from '@orisini/ui/lib/api'
import { useAuth } from '@orisini/ui/context/AuthContext'
import { Button } from '@orisini/ui/components/button'
import { Card } from '@orisini/ui/components/card'
import { Input } from '@orisini/ui/components/input'
import { Label } from '@orisini/ui/components/label'

/**
 * Profil dan password.
 *
 * Keduanya milik akun Orisini, bukan produk — mengubah zona waktu di sini
 * mengubah default penjadwalan di SELURUH produk, karena tiap produk membaca
 * `timezone` dari cermin user yang disegarkan dari sini.
 */
export default function SettingsPage() {
  const { me, refresh } = useAuth()
  const [name, setName] = useState(me?.user.name ?? '')
  const [timezone, setTimezone] = useState(me?.user.timezone ?? 'Asia/Jakarta')
  const [simpanProfil, setSimpanProfil] = useState(false)

  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [simpanPassword, setSimpanPassword] = useState(false)

  async function kirimProfil(e: React.FormEvent) {
    e.preventDefault()
    setSimpanProfil(true)
    try {
      await api.patch('/auth/profile', { name, timezone })
      await refresh()
      toast.success('Profile saved')
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Couldn't save profile")
    } finally {
      setSimpanProfil(false)
    }
  }

  async function kirimPassword(e: React.FormEvent) {
    e.preventDefault()
    setSimpanPassword(true)
    try {
      const res = await api.patch<{ note?: string }>('/auth/password', {
        currentPassword,
        newPassword,
      })
      setCurrentPassword('')
      setNewPassword('')
      toast.success(res.note ?? 'Password changed')
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Couldn't change password")
    } finally {
      setSimpanPassword(false)
    }
  }

  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-semibold tracking-tight">Settings</h1>

      <Card className="p-5">
        <form onSubmit={kirimProfil} className="space-y-4">
          <div>
            <h2 className="font-medium">Profile</h2>
            <p className="text-sm text-muted-foreground">
              This time zone becomes the default for scheduling across all products.
            </p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="name">Name</Label>
            <Input id="name" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="tz">Time zone</Label>
            <Input id="tz" value={timezone} onChange={(e) => setTimezone(e.target.value)} />
          </div>
          <Button type="submit" disabled={simpanProfil}>
            {simpanProfil ? 'Saving…' : 'Save profile'}
          </Button>
        </form>
      </Card>

      <Card className="p-5">
        <form onSubmit={kirimPassword} className="space-y-4">
          <div>
            <h2 className="font-medium">Password</h2>
            <p className="text-sm text-muted-foreground">
              Changing your password revokes all sessions, including on other products.
            </p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="cur">Current password</Label>
            <Input
              id="cur"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="new">New password</Label>
            <Input
              id="new"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <Button type="submit" disabled={simpanPassword}>
            {simpanPassword ? 'Changing…' : 'Change password'}
          </Button>
        </form>
      </Card>
    </div>
  )
}
